<template>
  <div class="admin-layout">
    <!-- 侧边导航 -->
    <aside class="sidebar">
      <div class="logo-container">
        <h2>后台管理</h2>
      </div>
      <nav class="sidebar-nav">
        <ul>
          <li @click="$router.push('/admin/products')" :class="{active: $route.path === '/admin/products'}">
            <i class="icon-product"></i> 产品管理
          </li>
          <li @click="$router.push('/admin/home-settings')" :class="{active: $route.path === '/admin/home-settings'}">
            <i class="icon-home"></i> 首页设置
          </li>
          <li @click="$router.push('/admin/banner-settings')" :class="{active: $route.path === '/admin/banner-settings'}">
            <i class="icon-banner"></i> Banner管理
          </li>
          <!-- 添加关于我们设置导航项 -->
          <li @click="$router.push('/admin/about-settings')" :class="{active: $route.path === '/admin/about-settings'}">
            <i class="icon-about"></i> 首页关于我们
          </li>
          <!-- 新增联系我们关于设置导航项 -->
          <li @click="$router.push('/admin/contact-about-settings')" :class="{active: $route.path === '/admin/contact-about-settings'}">
            <i class="icon-contact-about"></i> 关于我们页面
          </li>
          <!-- 新增技术支持管理导航项 -->
          <li @click="$router.push('/admin/tech-support')" :class="{active: $route.path === '/admin/tech-support'}">
            <i class="icon-tech-support"></i> 技术支持管理
          </li>
          <!-- 新增解决方案管理导航项 -->
          <li @click="$router.push('/admin/solutions')" :class="{active: $route.path === '/admin/solutions'}">
            <i class="icon-solution"></i> 解决方案管理
          </li>
          <!-- 新增AI模型配置导航项 -->
          <li @click="$router.push('/admin/ai-config')" :class="{active: $route.path === '/admin/ai-config'}">
            <i class="icon-ai"></i> AI模型配置
          </li>
        </ul>
      </nav>
    </aside>

    <!-- 主内容区域 -->
    <main class="main-content">
      <!-- 顶部工具栏 -->
      <header class="top-bar">
        <div class="user-info">
          <span>{{ username }}</span>
          <button @click="handleLogout" class="logout-btn">退出登录</button>
        </div>
      </header>

      <!-- 动态内容区域 -->
      <div class="content-container">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { logout } from '@/api/auth';

const username = ref('');
const router = useRouter();

onMounted(() => {
  // 检查登录状态
  const userStr = localStorage.getItem('adminUser');
  const token = localStorage.getItem('adminToken');
  if (!userStr || !token) {
    router.push('/admin/login');
    return;
  }
  // 获取用户信息
  const user = JSON.parse(userStr);
  username.value = user.username || '管理员';
});

const handleLogout = () => {
  logout();
  router.push('/admin/login');
};
</script>

<style scoped lang="scss">
.admin-layout {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 220px;
  background-color: #2c3e50;
  color: white;
  padding: 20px 0;
}

.logo-container {
  padding: 0 20px 20px;
  border-bottom: 1px solid #3d5a7a;
  margin-bottom: 20px;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
}

.sidebar-nav li {
  padding: 12px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.sidebar-nav li:hover,
.sidebar-nav li.active {
  background-color: #34495e;
}

.icon-product,
.icon-home,
.icon-banner,
.icon-about,
.icon-tech-support,
.icon-contact-about,
.icon-solution,
.icon-ai {
  text-align: left;
  margin-right: 2px;
  width: 20px;
  height: 20px;
  display: inline-block;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.top-bar {
  height: 60px;
  background-color: white;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
}

.content-container {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

/* 移动端响应式适配 */
@media (max-width: 768px) {
  .admin-layout {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    padding: 15px 0;
  }
  
  .logo-container {
    padding: 0 15px 15px;
    text-align: center;
  }
  
  .sidebar-nav {
    display: flex;
    overflow-x: auto;
    padding: 0 10px;
  }
  
  .sidebar-nav ul {
    display: flex;
    min-width: max-content;
    margin: 0;
  }
  
  .sidebar-nav li {
    padding: 10px 15px;
    white-space: nowrap;
    min-width: max-content;
  }
  
  .top-bar {
    height: 50px;
    padding: 0 15px;
  }
  
  .content-container {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .sidebar {
    padding: 10px 0;
  }
  
  .logo-container {
    padding: 0 10px 10px;
  }
  
  .sidebar-nav {
    padding: 0 5px;
  }
  
  .sidebar-nav li {
    padding: 8px 12px;
    font-size: 14px;
  }
  
  .icon-product,
  .icon-home,
  .icon-banner,
  .icon-about,
  .icon-tech-support,
  .icon-contact-about,
  .icon-solution {
    width: 16px;
    height: 16px;
  }
  
  .top-bar {
    height: 45px;
    padding: 0 10px;
    font-size: 14px;
  }
  
  .content-container {
    padding: 10px;
  }
}
</style>